import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { logout } from '../../action/UserAction';
import { myLog } from '../../../utils/Utility';
import noInternet from '../../../utils/images/no_internet.png';
import serverDown from '../../../utils/images/server_down.png';
import { PATH, ALERT, MESSAGE } from '../../../utils/Constants';

const NETWORK_RECONNECT_REFRESH_KEY = 'networkReconnectRefresh';
const NETWORK_RECONNECT_STOP_BEFORE_INIT_KEY = 'networkReconnectStopBeforeInit';
const NETWORK_RECONNECT_REFRESH_TTL = 30000;
const NETWORK_SCREEN_OVERLAY_STYLE = {
    zIndex: 99999,
};

const isVideoSessionPath = () => {
    const { pathname } = window.location;

    return pathname === '/video' || pathname.indexOf('/video-call/') !== -1;
};

/**
 * @package virtuowl
 * @type {React.ComponentClass}
 */
class NetworkScreen extends Component {
    static propTypes = {
        isOnline: PropTypes.bool,
        isNetworkProblem: PropTypes.bool,
        isUserActive: PropTypes.bool,
        deactivateUserScreen: PropTypes.bool,
    };

    isNetworkRecoveryStarted = false;

    /**
     * @description Render no internet screen design
     */
    state = {
        isRecoveringVideoSession: false,
        wasOnline: this.props.isOnline,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.wasOnline && nextProps.isOnline && isVideoSessionPath()) {
            return {
                isRecoveringVideoSession: true,
                wasOnline: nextProps.isOnline,
            };
        }

        if (prevState.wasOnline !== nextProps.isOnline) {
            return {
                isRecoveringVideoSession: nextProps.isOnline
                    ? prevState.isRecoveringVideoSession
                    : false,
                wasOnline: nextProps.isOnline,
            };
        }

        return null;
    }

    componentDidMount() {
        window.addEventListener('online', this.handleBrowserOnline);
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.handleBrowserOnline);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOnline && this.props.isOnline) {
            const isRefreshStarted = this.handleNetworkRestored();

            if (!isRefreshStarted && this.state.isRecoveringVideoSession) {
                this.setState({ isRecoveringVideoSession: false });
            }
        }
    }

    handleRefresh = () => {
        window.location.reload();
    };

    handleBrowserOnline = () => {
        this.handleNetworkRestored();
    };

    isVideoSessionRoute = () => {
        return isVideoSessionPath();
    };

    handleNetworkRestored = () => {
        if (!this.isVideoSessionRoute()) {
            return false;
        }

        if (this.isNetworkRecoveryStarted) {
            return true;
        }

        const now = Date.now();
        const currentPath = `${window.location.pathname}${window.location.search}`;
        let lastRefresh = null;

        try {
            lastRefresh = JSON.parse(
                sessionStorage.getItem(NETWORK_RECONNECT_REFRESH_KEY) || 'null'
            );
        } catch (e) {
            sessionStorage.removeItem(NETWORK_RECONNECT_REFRESH_KEY);
        }

        if (
            lastRefresh &&
            lastRefresh.path === currentPath &&
            now - lastRefresh.timestamp < NETWORK_RECONNECT_REFRESH_TTL
        ) {
            return false;
        }

        this.isNetworkRecoveryStarted = true;

        sessionStorage.setItem(
            NETWORK_RECONNECT_REFRESH_KEY,
            JSON.stringify({
                path: currentPath,
                timestamp: now,
            })
        );
        sessionStorage.setItem(NETWORK_RECONNECT_STOP_BEFORE_INIT_KEY, 'true');

        this.handleVideoSessionRecovery();
        return true;
    };

    handleVideoSessionRecovery = () => {
        this.handleRefresh();
    };

    //handleHomePage
    handleHomePage = () => {
        this.props.history.push(PATH.INDEX);
    };

    //renderLogoutAlert
    renderLogoutAlert = () => {
        logout((e) => {
            confirmAlert({
                closeOnClickOutside: false,
                title: ALERT.TITLE.APP_NAME,
                message: MESSAGE.STATUS_CODE_401_ERROR,
                buttons: [
                    {
                        label: 'ok',
                        onClick: () => (window.location.href = '/'),
                    },
                ],
            });
        });
    };

    //_renderView
    _renderView() {
        const { isOnline, isNetworkProblem, isUserActive, deactivateUser } = this.props;
        const { isRecoveringVideoSession } = this.state;
        myLog('Nointernet', isOnline);
        if (isUserActive) {
            logout(() => {
                window.location.href = '/';
            });
        } else if (!isOnline || isRecoveringVideoSession) {
            myLog('Nointernet', isOnline);
            return (
                <div className="fixed top-0 left-0 w-full h-full" style={NETWORK_SCREEN_OVERLAY_STYLE}>
                    <div className="flex items-center justify-center w-full h-full bg-neutral">
                        <div className="flex flex-col h-screen">
                            <div className="m-auto text-center">
                                <img src={noInternet} alt="" className="m-auto mb-8" />
                                <p className="mb-4 text-3xl font-medium">
                                    {isRecoveringVideoSession
                                        ? 'Reconnecting video session'
                                        : 'No Internet Connection'}
                                </p>
                                {isRecoveringVideoSession ? (
                                    <p>Restoring your call, please wait...</p>
                                ) : (
                                    <>
                                        <p>
                                            Yours Connection appers to be off-line.<br></br>Try to refresh
                                            the page
                                        </p>
                                        <button
                                            className="border border-primary text-primary py-1.5 px-6 rounded-full mt-6 font-weight-semibold"
                                            onClick={this.handleRefresh}
                                        >
                                            Refresh
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (isNetworkProblem) {
            myLog('isNetworkProblem', isNetworkProblem);
            return (
                <div className="fixed top-0 left-0 w-full h-full" style={NETWORK_SCREEN_OVERLAY_STYLE}>
                    <div className="flex items-center justify-center w-full h-full bg-UIBackground">
                        <div className="flex flex-col h-screen">
                            <div className="m-auto text-center">
                                <img src={serverDown} alt="" className="m-auto mb-8" />
                                <p className="mb-4 text-3xl font-medium text-white">
                                    Server down/ Server update
                                </p>
                                <p className="text-white">
                                    Something went wrong...<br></br>Please try again later
                                </p>
                                {window.location.pathname !== PATH.INDEX ? (
                                    <button
                                        className="bg-UIprimary text-white py-1.5 px-6 rounded-full mt-6 font-weight-semibold"
                                        onClick={() => {
                                            this.handleHomePage();
                                        }}
                                    >
                                        Back to home
                                    </button>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (deactivateUser) {
            myLog('deactivateUser', deactivateUser);
            return <>{this.renderLogoutAlert()}</>;
        } else {
            return <div />;
        }
    }
    /**
     * Render Page
     */
    render() {
        return (
            <div
                style={{
                    position: 'absolute',
                }}
            >
                {this._renderView()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.NetworkInState.isOnline,
        isNetworkProblem: state.NetworkInState.isNetworkProblem,
        isUserActive: state.NetworkInState.isUserActive,
        deactivateUser: state.NetworkInState.deactivateUserScreen,
    };
};

export default withRouter(connect(mapStateToProps)(NetworkScreen));
